import EditGroupModal from './EditGroupModal';

export default EditGroupModal;
